import type { RouteObject } from 'react-router';

import { PERMISSIONS } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { RequirePermission } from '@/features/auth';

export const attendanceRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.ATTENDANCE_READ} />,
    children: [
      {
        path: ROUTES.ATTENDANCE,
        lazy: async () => ({ Component: (await import('./pages/AttendancePage')).AttendancePage }),
      },
    ],
  },
];
